module.exports = __webpack_public_path__ + "img/pole-lb.d4404fe4.png";